<template>
  <div class="main-container rate-history-list">
    <loading :isShow="loading" />
    <div class="header">
      <span>产品名称：{{ pageQuery.productName }}</span>
      <span>产品编码： {{ pageQuery.productCode || '-' }}</span>
      <span>保司：{{ pageQuery.companyName || '-' }}</span>
      <span v-if="$units.superviseShowVal()">供应商：{{ pageQuery.supplierName || '-' }}</span>
      <Button @click="back(pageQuery.backUrl)" type="primary" ghost>返回</Button>
    </div>
    <div class="search-box min">
      <div class="input-item" style="width: 400px">
        <span class="label">政策有效期</span>
        <DatePicker
          type="datetimerange"
          split-panels
          separator=" 至 "
          transfer
          :value="searchParams.date"
          @on-change="searchParams.date = $event"
          format="yyyy-MM-dd HH:mm"
          placeholder="选择日期"
        ></DatePicker>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">搜索</Button>
      </div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData" v-if="tableData.length">
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="openDetail(row)"> 查看费率 </span>
        </template>
      </Table>
      <no-data v-else style="margin-top: 250px"></no-data>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
    </div>
  </div>
</template>

<script>
import { common, pageTool } from '@/api/mixins';
import noData from '@/components/commons/noData';
export default {
  mixins: [common, pageTool],
  components: { noData },
  data() {
    return {
      loading: false,
      list: [],
      productCode: '',// 产品编码
      pageQuery: {},
      columns: [
        {
          title: '序号',
          type: 'index',
          align: 'center',
          width: 60
        },
        {
          title: '版本号',
          key: 'versionNo',
          align: 'center',
          minWidth: 280
        },
        {
          title: '生效时间',
          key: 'startTime',
          align: 'center',
          minWidth: 200,
          render(h, params) {
            return (
              <div>{params.row.startTime || '-'}</div>
            );
          }
        },
        {
          title: '失效时间',
          key: 'endTime',
          align: 'center',
          minWidth: 200
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 120
        }
      ]
    };
  },
  mounted() {
    this.pageQuery = this.$route.query;
    this.initListParams('/buz/commission/queryMerchantCommissionVersion');
  },
  activated(){
    this.getList();
  },
  methods: {
    // 设置权限头
    setReqParams(params) {
      params.apiPermissionCode = 'pro_7_1';
    },
    setListParams(params) {
      params.productCode = this.pageQuery.productCode;
      console.log(params.date);
      if (params.date && params.date[0]) {
        // 政策有效期
        params.startTime = params.date[0] + ':00';
        params.endTime = params.date[1] + ':59';
      }
      delete params.date;
      delete params.dateType;
      return params;
    },
    openDetail(item) {
      this.openPageTabTags('/productResource/feeUpstreamCofnig/rateHistoryDetail', {
        ...this.pageQuery,
        versionId : item.id,
        backUrl: this.delQueStr(this.$route.fullPath, 'time')
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.rate-history-list {
  .header {
    font-size: 14px;
    color: #333;
    margin-bottom: 20px;
    padding-right: 70px;
    position: relative;
    line-height: 30px;
    span {
      margin-right: 50px;
    }
    .ivu-btn {
      position: absolute;
      right: 0;
    }
  }
  .search-box.min .input-item {
    width: 400px !important;
  }
}
</style>
